import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { SimpleRequestString } from 'src/app/shared/models/SimpleRequestString';
import { AlertService } from 'src/app/shared/services/alert.service';

import { TooltipDirective } from '../../directives/tooltip.directive';
@Component({
    selector: 'app-security-verification-options',
    templateUrl: './security-verification-options.component.html',
    styleUrl: './security-verification-options.component.css',
    imports: [TooltipDirective]
})
export class SecurityVerificationOptionsComponent {

  selectedMethod: string = 'email'; // Default selection
  email?: string = 'ae.cook@example.com';
  phone?: string = '+50499601488';
  requestString: SimpleRequestString = {} as SimpleRequestString;


  constructor(private router: Router,
    private alertService: AlertService,
    private loginService: LoginService) {


  }

  ngOnInit(): void {
    
    
    const email = localStorage.getItem('UserEmail');
    
    this.requestString.value = email ? email : '';
    this.loginService.getUserByEmail(this.requestString).subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data !== null) {
          
          this.phone = Data.value;
          this.email = Data.secondValue;
        } 
      }
    );
  }


  selectMethod(method: string): void {
    
    this.selectedMethod = method;

  }

  get isSmsSelected(): string {
    return this.selectedMethod === 'sms' ? 'selected' : '';
  }
  get isEmailSelected(): string {
    return this.selectedMethod === 'email' ? 'selected' : '';
  }

  maskPhoneNumber(): string {
    if (!this.phone) return '+1•••••••890';

    // Keep country code visible if present
    const plusIndex = this.phone.indexOf('+');
    let visibleStart = '';
    let rest = this.phone;

    if (plusIndex !== -1) {
      visibleStart = this.phone.substring(0, plusIndex + 2); // Keep + and 1 digit
      rest = this.phone.substring(plusIndex + 2);
    } else {
      visibleStart = this.phone.substring(0, 2);
      rest = this.phone.substring(2);
    }

    // Keep last 3 digits visible
    const visibleEnd = rest.length > 3 ? rest.substring(rest.length - 3) : '';
    const maskedMiddle = rest.length > 3 ? '•'.repeat(rest.length - 3) : '';

    return visibleStart + maskedMiddle + visibleEnd;
  }

  maskEmail(): string {
    if (!this.email) return 'us••••@••••.com';

    const atIndex = this.email.indexOf('@');
    if (atIndex === -1) return 'us••••@••••.com';

    const username = this.email.substring(0, atIndex);
    const domain = this.email.substring(atIndex + 1);
    const dotIndex = domain.lastIndexOf('.');

    // Mask username (show first 2 chars if length > 2)
    let maskedUsername = username.length > 2
      ? username.substring(0, 2) + '•'.repeat(username.length - 2)
      : '•'.repeat(username.length);

    // Mask domain (show TLD)
    let maskedDomain = '';
    if (dotIndex !== -1) {
      const domainName = domain.substring(0, dotIndex);
      const tld = domain.substring(dotIndex);
      maskedDomain = '•'.repeat(domainName.length) + tld;
    } else {
      maskedDomain = '•'.repeat(domain.length);
    }

    return maskedUsername + '@' + maskedDomain;
  }

  sendVerificationCode() {
    if (this.selectedMethod === 'email') {
      this.loginService.sendVerificationEmail(this.requestString).subscribe(
        ({ StatusCode, Message, Data }) => {
          
          if (Data) {
            this.alertService.success('Verification code sent to your email.');

            localStorage.setItem('verifyCodeBy', this.selectedMethod);
            setTimeout(() => {
              this.router.navigate(['/security-verification']);
            }, 2000);
          } else {
            this.alertService.error('Failed to send verification code. Please try again.');
          }
        },
        error => {
          this.alertService.error('Error sending verification code. Please try again later.');
        }
      );
    } else if (this.selectedMethod === 'sms') {
      this.loginService.sendVerificationCodeSMS(this.requestString).subscribe(
        (response : boolean) => {
          
          if (response) {
            this.alertService.success('Verification code sent to your phone.');
            localStorage.setItem('verifyCodeBy', this.selectedMethod);
            setTimeout(() => {
              this.router.navigate(['/security-verification']);
            }, 2000);
          } else {
            this.alertService.error('Failed to send verification code. Please try again.');
          }
        },
        error => {
          this.alertService.error('Error sending verification code. Please try again later.');
        }
      );
    }
  }

  goBack(): void {
    this.router.navigate(['/login']);
    localStorage.clear();
  }

}
